import english from './english';
import japanese from './japanese';
import { getLanguage } from '../helpers/url';
import chinese from './chinese';
import french from './french';
function getCurrentLanguage() {
    let currentLanguage = getLanguage();
    let languageFiles = { en: english, ja: japanese, zh: chinese, fr: french };
    return languageFiles[currentLanguage] || english;
}
export default getCurrentLanguage();
